export default __webpack_public_path__ + "static/media/river_logo.d406874e.svg";